<template>
  <div class="news1">
    <p><b>摘要：</b>为了顺利纺制细特涤纶纤维、普通棉型涤纶纤维和竹纤维三组分复合细号纱线，从客户的质量要求出发，对各工序影响质量的因素进行了分析和研究，重点采取原料选配，清梳工序开松梳理，并条工序混纺比准确和并合均匀，粗纱工序优化工艺配置，解决粗纱疵点及“大肚纱”问题，细纱工序减少毛羽和断关，络筒工序控制毛羽和棉结增长率等措施，最终成纱质量满足了客户要求。</p>
    <br><p><b>关键词：</b>细特涤纶纤维；竹纤维；工艺配置；技术措施；棉结；成纱质量</p>
    <p>服装面料服用性能越来越受到人们的关注，新型纤维的开发和应用适应了这一要求。适应市场要求，开发了细特涤纶与竹纤维混纺细号纱，用以织造细号高密服装面料。现以0.89dtex×38mm涤纶纤维40%，1.56dtex×38mm涤纶纤维40%与1.33dtex×38mm竹纤维20%三组分混纺9tex/65s剑杆织机用纱为例，介绍其纺纱实践。</p>
    <br><p><b>1、原料的性能及特点</b></p>
    <p>细特涤纶纤维作为新型的差别化纤维材料，具有强度高，模量大，伸长小，尺寸稳定性好等特点，该纤维质地柔软，抱合力好，光泽柔和，具有一定的芯吸效应。竹纤维吸湿性强，湿强低，手感柔软，富有光泽，生产过程中没有明显静电，可纺性好，易染色，具有独特的天然抗菌，防紫外线功能。竹纤维与细特涤纶混纺而成的细号纱织物，透气性，吸湿性，悬垂性，有着比普通棉型化纤混纺织物无法比拟的优越性。</p>
    <br><p><b>2、工艺流程</b></p>
    <p>A002D抓棉机→A006B自动混棉机→A036C梳针辊筒开棉机→A092A棉箱给棉机→A076C单打手成卷机→A186梳棉机→A272F并条机（细特涤纶和普通棉型涤纶混纤生条预并）→A272F并条机（竹纤维生条预并）→A272F并条机（混一混二）→FA315并条机（混三）→FA496粗纱机→FA506细纱机→1332M槽筒机。</p>
    <br><p><b>3、各工序工艺参数和技术措施</b></p>
    <p>3.1清棉工序</p>
    <p>细特涤纶和普通棉型涤纶各占50%的比例，采用棉台混和成卷，竹纤维单独成卷。清棉工序总的工艺原则为：“精细抓取，输送通畅，不挂不堵，少打少损伤，少落少翻滚，多松多梳，棉箱容量稳定，纤维充分混和，均匀凝聚，均匀成卷。”主要参数：A002D打手速度720r/min，A036C梳针打手速度480r/min，A076C打手速度900r/min，风扇速度1320r/ min。涤卷重399g/m，竹纤维卷重400g/m。</p>
    <p>3.2梳棉工序</p>
    <p>细特涤纶和普通棉型涤纶纤维棉台混和成卷，由于纤维细度的差异，在梳棉工序采取“统筹兼顾，轻打击，多梳理，紧隔距，防缠绕”的工艺原则。竹纤维梳棉棉网清晰度差，有云斑。采取机械抄针和人工清刷等措施对盖板道夫做清洁，保证针布齿间无嵌花无嵌杂。根据竹纤维原料性能，湿强低，开松程度不够，有束丝状纤维团，特别在梳棉工序纤维梳理难度加大，采取少打击损伤，多梳理多排结，相对偏紧隔距，相对多的盖板花量，确保棉网质量。在正常生产情况下，一是控制生条重不匀率在3.5%以内；二是抽样测试生条棉结控制在2粒/克以内；三是台台验收和重点检查棉网质量达到一级水平。主要工艺参数：锡林速度330r/ min，刺辊速度800r/ min，道夫速度15r/ min，锡林—盖板隔距0.20mm、0.175mm、0.15mm、0.15mm、0.175mm。涤纶生条19.9g/5m，竹纤维生条18.0g/5m。</p>
    <p>3.3 并条工序</p>
    <p>细特涤纶40%，普通棉型涤纶40%，竹纤维20%，可以说是三合一产品。一是为了确保混纺比准确和改善生条中纤维的伸直程度，采取涤纶生条预并和竹纤维预并工艺；二是为了确保纤维混和均匀，采取三道混并工艺。并条工序在实际生产过程中，混二出现条子输出不顺畅堵塞圈条盘现象，采取较低输出条速，用酒精和滑石粉擦拭圈条盘输条通道，保持光洁，检查修复输出压辊，使其保持光滑无毛刺，输出压辊牙轮咬合适当，车间温温度适当调整等措施，解决了条子堵塞圈条盘的问题。测试熟条条干CV%1.94。</p>
    <p>主要工艺参数如下：</p>
    <p><img src="../../assets/img/news13-1.jpg"/></p>
    <p>3.4 粗纱工序</p>
    <p>根据混纺纤维长度和细特涤纶特性，粗纱工序采取“重加压，大隔距，较大后区牵伸倍数，稍大的钳口，合适的捻度，前后排适宜的假捻器，适当的粗纱张力及伸长，适宜的卷绕密度”工艺原则。在执行原上机工艺参数的前提下，在纺纱过程中，发现有牵伸不开的粗纱疵点和“大肚纱”现象，分析查找原因，采取放大钳口措施，由原5.0mm调整到5.5mm，纺纱做试验，有效果，但不明显。为了确保成纱质量，防止粗纱纱疵流入下工序，又在此基础上加大后区牵伸倍数，由1.28倍调整到1.30倍。通过以上措施，解决了问题，使纺纱得以正常进行。主要工艺参数：干定量3.8g/10m，锭速600r/ min，后区牵伸倍数1.30倍，钳口5.5mm，罗拉表面隔距mm 12×27×30,设计捻度3.188捻/10cm，捻系数63.03。测试条干CV% 3.29。</p>
    <p>3.5 细纱工序</p>
    <p>在气动加压V型牵伸配置的细纱机FA506上纺制，采取的工艺原则为“重加压，大隔距，较大后区牵伸，较低锭速，选用中硬性抗静电处理胶辊，钢领钢丝圈合适配置，适当的捻系数。”主要工艺参数：锭速14000r/min，前罗拉速度143r/min，后区牵伸倍数1.24倍，罗拉隔距mm 18×26,钳口2.5mm，设计捻度125捻/10cm，捻系数375,布雷克进口钢铃直径38mm,u110/0钢丝圈，压力表读数0.12MPa。</p>
    <p>成纱质量指标如下：</p>
    <p><img src="../../assets/img/news13-2.jpg"/></p>
    <p>3.6 络筒工序</p>
    <p>竹纤维与细特涤纶表面平直光滑，受外力作用，纤维间易产生相对滑移，断头增加，采取低速，小张力，同时保证筒子纱手感有弹性，以防过紧造成强力和弹性损失。采用金属槽筒，保持纱线通道光洁无毛刺；选用合适空气捻结器，确保接头强力和外观质量;电清参数设置合理，提高纱疵清除效率。主要参数：络筒速度470m/min，材料系数6.0,电清参数：短粗+150%×2.0cm，长粗+60%×20cm，长细-70%×40cm，FC309气旋式空气捻接器。</p>
    <br><p><b>4、结束语</b></p>
    <p>经小批量试纺客户用纱后，反映成纱棉结较高，影响布面质量。对此质量技术部门及各生产工序联合对存在的质量问题，从流程控制方面逐一剖析，采取以下措施。</p>
    <p>4.1 原料选择：普通棉型涤纶纤维选择纤度由原1.56dtex×38mm调整为纤度1.33dtex×38mm。</p>
    <p>4.2 竹纤维原料上包前要测试实际回潮率。若回潮率≥12%时，说明回潮率较大，纤维断裂强度低，在开松梳理过程中易损伤和扭结，可采取松包撒湿处理。</p>
    <p>4.3 注重清梳工序工艺参数的优化和技术措施的执行。清梳工序扯松梳理元件要做到合适选型，并且保持机械状态良好，提高纤维伸直程度和单纤化率。</p>
    <p>4.4 成纱毛羽产生在细纱，增长在络筒，同样成纱棉结在络筒工序相对管纱的增长率也要控制在内控指标要求范围内。毛羽和棉结相对管纱的增长率，可以通过筒管对比试验和加强抽样测试来进行监控。</p>
    <p>4.5 经过技术攻关和加强管理，最终产品满足了客户要求。</p>
    <br><p><b>参考文献</b></p>
    <p>（1）张同华等.棉竹涤混纺针织纱的生产[J].棉纺织技术，2004,32（6）：37-39.</p>
    <p>（2）詹树改.竹涤棉混纺针织彩色粒子纱的生产[J].棉纺织技术.2008,36（5）：30-32.</p>
    <p>（3）张玉清等.Modal细特涤纶羊绒混纺纱的试纺及成纱性能 [J].2007,35(5):33-35.</p>
    <p style="color: #999; text-align: center">来源：TTEB</p>
  </div>

</template>
<script>
  export default {
    name: 'news13'
  }
</script>

<style scoped>
  .news1{
    text-align: left;
    font-size: 18px;
    line-height: 200%;
    background: #fff;
    color: #333;
    margin-top: -10px;
    padding: 20px 30px;
  }

  .news1 p{
    font-family: 微软雅黑;
    text-indent: 2em;
    line-height: 145%;
    margin: 12px 0;
  }

  .news1 p img{
    display: block;
    max-width: 100%;
    margin: 12px auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/new/news13.vue